import { isDefined } from "../../helpers";
export default function (store, { value, open, dropdown, focus }) {
    const search = store.getState().stateSearch;
    store.setState({
        stateSearch: {
            value,
            open: isDefined(open) ? open : search?.open,
            dropdown: isDefined(dropdown) ? dropdown : search?.dropdown,
            focus: isDefined(focus) ? focus : search?.focus,
        },
    });
}
//# sourceMappingURL=search.js.map